var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mymodal',{ref:"modal",attrs:{"title":"Группировка","ok":"Применить","reset":_vm.reset,"check":_vm.check,"submit":_vm.submit}},[_c('b-form-checkbox',{model:{value:(_vm.all),callback:function ($$v) {_vm.all=$$v},expression:"all"}},[_vm._v("Группировать объекты, разгруппированные присвоением оценочной группы / подгруппы из справочника")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }